module.exports = __webpack_public_path__ + "img/5_goje.52dc909d.jpg";